import { initialState } from "./state";

export const setPortalLiveStats = (state, payload) => {
  state.portalLiveStats = payload;
};

export const reset = (state) => {
  const s = initialState();
  Object.keys(s).forEach((key) => {
    state[key] = s[key];
  });
};
